import { render, staticRenderFns } from "./resource-allocation.vue?vue&type=template&id=70af4635&scoped=true"
import script from "./resource-allocation.vue?vue&type=script&lang=js"
export * from "./resource-allocation.vue?vue&type=script&lang=js"
import style0 from "./resource-allocation.vue?vue&type=style&index=0&id=70af4635&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70af4635",
  null
  
)

export default component.exports